import React from "react";
import ReactDOM from "react-dom";
import FormCep from "./components/FormCep/FormCep";

ReactDOM.render(
  <React.StrictMode>
    <FormCep />
  </React.StrictMode>,
  document.getElementById("root")
);
